module.exports = __webpack_public_path__ + "static/media/ic_info.fa819367.svg";